import { useEffect, useState, useRef, Fragment } from 'react';
import * as fabric from "fabric";
import {addRect, addEllipse, setUpRect} from './canvasFunctions';
import { apiCall } from "../../narrativeUtils/fetch";
import classNames from 'classnames';
import Config from "../../../Config.json";
import { he } from 'date-fns/locale';

function App(props) {

  const uniqueIdRef = useRef(`canvas-${Math.random().toString(36).slice(2, 11)}`);
  const canvasRef = useRef(null);
  const xPosRef = useRef();
  const yPosRef = useRef();
  const widthRef = useRef();
  const heightRef = useRef();
  // const svgDimsRef = useRef();
  const canvasBoxRef = useRef();
  const canvasRotateRef = useRef();
  const changesRef = useRef(false);
  const sizeChangesRef = useRef(false);
  const selfSaveRef = useRef(false);
  const [loaded, setLoaded] = useState(false);
  const [obj, setObj] = useState();
  const [objType, setObjType] = useState(null);
  const [activeTool, setActiveTool] = useState(null);
  const [saving, setSaving] = useState(false);

  function disableInteractivity(canvas) {
  canvas.selection = false;
  canvas.forEachObject(obj => {
    obj.selectable = false;
    obj.evented = false;
  });
  canvas.isDrawingMode = false;
  try {
    canvas.renderAll();
  } catch (e) {
    console.warn('disableInteractivity renderAll skipped:', e.message);
  }
}

  const initCanvas = () => {
    const canvasEl = document.getElementById(uniqueIdRef.current);
    return new fabric.Canvas(canvasEl, {
      height: props.height,
      width: props.width,
      backgroundColor: "transparent",
      // uniScaleTransform: false
    });
  };


  useEffect(() => {
    const canvasEl = document.getElementById(uniqueIdRef.current);
    if (!canvasEl) return;

    canvasRef.current = initCanvas();

    return () => {
       if (canvasRef.current) {
          canvasRef.current.dispose();
          canvasRef.current = null;
        }
    }
  }, [])


  useEffect(() => {
    // console.log('paper loaded', loaded)
    if (!props.editing && canvasRef.current) {

      disableInteractivity(canvasRef.current)
    }

  }, [loaded, props.editing])

  useEffect(() => {
    if (!props.editing) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        props.escClear();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [props.editing]);

  useEffect(() => {
      if (activeTool !== props.tool) {
        setActiveTool(props.tool)
      }  
      return () => {
      };
    }, [props.tool])

    useEffect(() => {
      
      if (objType === "path") {
        canvasRef.current.uniScaleTransform = false;
      } else {
        canvasRef.current.uniScaleTransform = true;
      }
    }, [objType]);

  //   useEffect(() => {
  // const canvas = canvasRef.current;
  // if (!canvas) return;

//   const handleDelete = (e) => {
//     if (e.key === 'Delete' || e.key === 'Backspace') {
//       const activeObj = canvas.getActiveObject();
//       if (activeObj && activeObj === line) {
//         canvas.remove(activeObj);
//         setLine(null);
//       }
//     }
//   };

//   window.addEventListener('keydown', handleDelete);
//   return () => window.removeEventListener('keydown', handleDelete);
// }, [line]);

  useEffect(() => {

    if (!activeTool || !canvasRef.current) return;
        setLoaded(true);  
        // setChanges(true);
        changesRef.current = true;
      switch (activeTool) {
        
        case 'drawing':
          canvasRef.current.isDrawingMode = true;
          canvasRef.current.freeDrawingBrush = new fabric.PencilBrush(canvasRef.current);
          canvasRef.current.freeDrawingBrush.width = 1;
          canvasRef.current.freeDrawingBrush.color = '#333'; // default black
          canvasRef.current.on('path:created', function(event) {
            const path = event.path;
            setObj(path);
            setObjType('path');
            canvasRef.current.setActiveObject(path);
            setTimeout(() => onSave(), 100);
          });
          break;
        case 'ellipse':
           const ellipseObj = new fabric.Ellipse({
            height: 200,
            width: 200,
            fill: '#aaa',
            rx: 200 / 2,
            ry: 200 / 2,
            originX: 'left',
            originY: 'top',
          });
          console.log('ellipse', ellipseObj)
          canvasRef.current.centerObject(ellipseObj);
          canvasRef.current.add(ellipseObj);
          canvasRef.current.setActiveObject(ellipseObj);
          setObj(ellipseObj);
          setObjType('ellipse');
          setTimeout(() => onSave(), 100);
          break;
        case 'rectangle':
          const rectObj = new fabric.Rect({
            height: 200,
            width: 200,
            fill: '#ccc',
            rx: 0,
            ry: 0,
            originX: 'left',
            originY: 'top',
            scaleX: 1,
            scaleY: 1
          });
          canvasRef.current.centerObject(rectObj);
          canvasRef.current.add(rectObj);
          canvasRef.current.setActiveObject(rectObj);
          setObj(rectObj);
          setObjType('rect');
          setTimeout(() => onSave(), 100);
          break;
        case 'star':
          const starPoints = [];
          const cx = props.width / 2; // Center X
          const cy = props.height / 2; // Center Y
          const spikes = 5;
          const outerRadius = 100;
          const innerRadius = 40;

          for (let i = 0; i < spikes * 2; i++) {
            const angle = (Math.PI / spikes) * i - Math.PI / 2; // rotate -90 degrees
            const radius = i % 2 === 0 ? outerRadius : innerRadius;
            const x = cx + Math.cos(angle) * radius;
            const y = cy + Math.sin(angle) * radius;
            starPoints.push({ x, y });
          }

          const star = new fabric.Polygon(starPoints, {
            fill: '#ccc',
            stroke: null,
            strokeWidth: 1,
            selectable: true,
            originX: 'left',
            originY: 'top',
          });

          canvasRef.current.add(star);
          canvasRef.current.centerObject(star);
          canvasRef.current.setActiveObject(star);
          setObj(star);
          setObjType('polygon');
          setTimeout(() => onSave(), 100);
          break;
        case 'line':
          
          if (objType === 'line') {
            console.log("A line already exists. Only one line allowed.");
            return;
          }

          let isDrawing = false;
          let newLine;
          
          canvasRef.current.isDrawingMode = false;

          canvasRef.current.on('mouse:down', function (opt) {
            if (newLine) return;

            isDrawing = true;
            const pointer = canvasRef.current.getPointer(opt.e);

            newLine = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
              stroke: '#333',
              strokeWidth: 1,
              selectable: true,
              hasControls: true,
              hasBorders: false,
            });

            // Add custom controls to allow moving endpoints
            newLine.controls = {
              p1: new fabric.Control({
                x: -0.5,
                y: 0,
                cursorStyle: 'pointer',
                actionHandler: (eventData, transform, x, y) => {
                  const pointer = canvasRef.current.getPointer(eventData.e);
                  transform.target.set({ x1: pointer.x, y1: pointer.y });
                  transform.target.setCoords();
                  canvasRef.current.renderAll();
                  return true;
                },
              }),
              p2: new fabric.Control({
                x: 0.5,
                y: 0,
                cursorStyle: 'pointer',
                actionHandler: (eventData, transform, x, y) => {
                  const pointer = canvasRef.current.getPointer(eventData.e);
                  transform.target.set({ x2: pointer.x, y2: pointer.y });
                  transform.target.setCoords();
                  canvasRef.current.renderAll();
                  return true;
                },
              }),
            };

            canvasRef.current.add(newLine);
            
          });

          canvasRef.current.on('mouse:move', function (opt) {
            if (!isDrawing || !newLine) return;
            const pointer = canvasRef.current.getPointer(opt.e);
            newLine.set({ x2: pointer.x, y2: pointer.y });
            canvasRef.current.renderAll();
          });

          canvasRef.current.on('mouse:up', function () {
            if (!isDrawing || !newLine) return;
            isDrawing = false;
            newLine.setCoords();
            setObj(newLine);
            setObjType('line');
            setTimeout(() => onSave(), 100);
          });
          break;
        case 'arrow':
          // Prevent multiple arrows
          if (objType === 'arrow') {
            console.log("An arrow already exists. Only one arrow allowed.");
            return;
          }
          // Arrow path matching desired SVG shape
          const arrowPath = 'M13,14l-1.43-1.4,4.6-4.6H0v-2h16.18L11.6,1.4l1.4-1.4,7,7-7,7Z';
          const arrow = new fabric.Path(arrowPath, {
            fill: '#ccc',
            stroke: null,
            selectable: true,
            originX: 'left',
            originY: 'top',
            strokeUniform: true
          });
          // Scale and position
          arrow.scaleToWidth(200);
          arrow.scaleToHeight(100);
          canvasRef.current.add(arrow);
          canvasRef.current.centerObject(arrow);
          canvasRef.current.setActiveObject(arrow);
          setObj(arrow);
          setObjType('arrow');
          setTimeout(() => onSave(), 100);
          break;
        default:
          canvasRef.current.isDrawingMode = false;
          break;
      
      }
    
  }, [activeTool])
  
  

  function loadJSON(){
      setTimeout(() => {
        canvasRef.current && canvasRef.current.loadFromJSON(props.svgJSON, () => {
          let margin = 0;
          if (!props.editing && props.svgJSON.objects[0].strokeWidth) {
            margin = props.svgJSON.objects[0].strokeWidth * props.zoomRatio * 2;
          }
          // console.log('canvas margin', margin, props.svgJSON.objects[0].strokeWidth)
          canvasRef.current.setHeight(props.height+margin);
          canvasRef.current.setWidth(props.width+margin);       
          canvasRef.current.set({
            top: (yPosRef.current ? yPosRef.current : props.y_pos),
            left: (xPosRef.current ?  xPosRef.current : props.x_pos)
          })

         
          if (props.editing) {
              placeObjects();
          } else {
            // setLoaded(true)
               
            setLoaded(true);
        

          }
        
        });

        //  console.log('props.svgJSON', props.objId, props.svgJSON, props.y_pos, props.x_pos, props.width, props.height);
      }, 50);
  }

  useEffect(() => {
    if (selfSaveRef.current) return;
    if (props.svgJSON && canvasRef.current && props.width && props.height) {
     loadJSON();
    }
  }, [props.svgJSON, props.width, props.height]);

  useEffect(() => {
    if (selfSaveRef.current) return;
    if (!props.editing || !canvasRef.current) return;
    const activeObj = canvasRef.current.getActiveObject();
    if (!activeObj) return;

    activeObj.set({ left: props.x_pos, top: props.y_pos });
    activeObj.setCoords();
    canvasRef.current.requestRenderAll();
    xPosRef.current = props.x_pos;
    yPosRef.current = props.y_pos;
  }, [props.x_pos, props.y_pos]);

  useEffect(() => {
    if (selfSaveRef.current) return;
    if (!props.editing || !canvasRef.current) return;
    const activeObj = canvasRef.current.getActiveObject();
    if (!activeObj) return;

    activeObj.set({ angle: props.rotation });
    activeObj.setCoords();
    canvasRef.current.requestRenderAll();
  }, [props.rotation]);

   useEffect(() => {
    if (props.svgJSON && canvasRef.current && props.reloadFrame > 0) {
      console.log('reload', props.reloadFrame)
     loadJSON();
    }
  }, [props.reloadFrame]);


  function placeObjects() {
     setTimeout(() => {
      const objects = canvasRef.current && canvasRef.current.getObjects();

      objects.forEach(obj0 => {
        let top;
        let left;

        top = yPosRef.current ? yPosRef.current : props.y_pos;
        left =  xPosRef.current ?  xPosRef.current : props.x_pos;

        switch (obj0.type) {
          case 'ellipse':
            obj0.set({
              ry: heightRef.current ? heightRef.current/2 : props.objHeight/2,
              rx: widthRef.current ? widthRef.current/2  : props.objWidth/2,
              height: heightRef.current ? heightRef.current : props.objHeight,
              width: widthRef.current ? widthRef.current : props.objWidth,
              scaleY: 1,
              scaleX: 1,
              top: top,
              left: left,
              fill: props.svgJSON.objects[0].fill,
              stroke: props.svgJSON.objects[0].stroke,
              strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
              lockRotation: true,
              hasRotatingPoint: false,
              angle: props.rotation,
              strokeUniform: true,
            });
            setObj(obj0)
            setObjType('ellipse')
            break;
          case 'polygon':
              obj0.set({
                left: left,
                top: top,
                angle: props.rotation,
                strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
                strokeUniform: true,
              });
              obj0.scaleToWidth(widthRef.current ? widthRef.current : props.objWidth,);
              obj0.scaleToHeight( heightRef.current ? heightRef.current : props.objHeight);
              obj0.setCoords();
              // save to state
              setObj(obj0);
              setObjType('polygon');
            
            break;
          case 'path':
            // determine desired display dimensions
            const pathWidth = widthRef.current ? widthRef.current : props.objWidth;
            const pathHeight = heightRef.current ? heightRef.current : props.objHeight;
            // clear any rotation so scaling uses original bounding box
            obj0.set({
              angle: 0
            });
            // Set scaleX/scaleY independently to allow non-uniform scaling.
            // scaleToWidth/scaleToHeight both call scale() which sets uniform
            // scale, so the second call overwrites the first.
            obj0.set({
              scaleX: pathWidth / obj0.width,
              scaleY: pathHeight / obj0.height
            });
            // apply rotation, position, and zoomed stroke
            obj0.set({
              left: left,
              top: top,
              angle: props.rotation,
              strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
              strokeUniform: true
            });
            // update coordinates for transformed object
            obj0.setCoords();
            // save to state
            setObj(obj0);
            setObjType('path');
            // canvasRef.current.uniScaleTransform = true;
            break;
          case 'rect':
            heightRef.current ? obj0.scaleToHeight(heightRef.current) : obj0.scaleToHeight(obj0.height*props.zoomRatio);
            widthRef.current ? obj0.scaleToWidth(widthRef.current) :  obj0.scaleToWidth(obj0.width*props.zoomRatio);
            obj0.set({
              top: top,
              left: left,
              height: heightRef.current ? heightRef.current : props.objHeight,
              width: widthRef.current ? widthRef.current : props.objWidth,
              scaleY: 1,
              scaleX: 1,
              fill: props.svgJSON.objects[0].fill,
              stroke: props.svgJSON.objects[0].stroke,
              strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
              lockRotation: true,
              hasRotatingPoint: false,
              angle: props.rotation,
              strokeUniform: true,
            });
            setObj(obj0);
            setObjType('rect');
            break;
          default:
            heightRef.current ? obj0.scaleToHeight(heightRef.current) : obj0.scaleToHeight(obj0.height*props.zoomRatio);
            widthRef.current ? obj0.scaleToWidth(widthRef.current) :  obj0.scaleToWidth(obj0.width*props.zoomRatio);
            obj0.set({
              top: top,
              left: left,
              height: heightRef.current ? heightRef.current : props.objHeight,
              width: widthRef.current ? widthRef.current : props.objWidth,
              scaleY: 1,
              scaleX: 1,
              fill: props.svgJSON.objects[0].fill,
              stroke: props.svgJSON.objects[0].stroke,
              strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
              lockRotation: true,
              hasRotatingPoint: false,
              angle: props.rotation,
              strokeUniform: true
            });
            setObj(obj0);
            setObjType(obj0.type);
            break;
        }


        obj0.setControlsVisibility({
          mtr: false // "mtr" = middle top rotate handle
        });
        obj0.setCoords();
       canvasRef.current.setActiveObject(obj0)
        
      });
      

      canvasRef.current.requestRenderAll();

      setLoaded(true);

    }, 0); 
  }

useEffect(() => {
  const canvas = canvasRef.current;
  if (!canvas || !obj || activeTool) return;

  let saveTimeout;
  let prevWidth = obj.width * obj.scaleX;
  let prevHeight = obj.height * obj.scaleY;

  const markAsChanged = () => {
    changesRef.current = true;
    if (saveTimeout) clearTimeout(saveTimeout);
    saveTimeout = setTimeout(() => {
      onSave();
    }, 500);
  };

  // Background click to exit is handled by the sketchCover overlay + Escape key.
  // Registering mouse:down here caused accidental exits when dragging near object edges.
  
    const handleSizeChange = () => {
      const newWidth = obj.width * obj.scaleX;
      const newHeight = obj.height * obj.scaleY;

      const widthChanged = Math.abs(newWidth - prevWidth) > 0.5;
      const heightChanged = Math.abs(newHeight - prevHeight) > 0.5;

      if (widthChanged || heightChanged) {
        sizeChangesRef.current = true;

        // svgDimsRef.current = [newWidth+props.svgJSON.objects[0].strokeWidth*props.zoomRatio,newHeight+props.svgJSON.objects[0].strokeWidth*props.zoomRatio];

        // console.log('svgDimsRef.current', svgDimsRef.current)

        if (saveTimeout) clearTimeout(saveTimeout);
        saveTimeout = setTimeout(() => {
          onSave();
        }, 500);

        prevWidth = newWidth;
        prevHeight = newHeight;
      }
    };

const managePathMove = (target) => {
  if (target.type === 'path' && props.rotation !== 0) {
    const pathWidth = widthRef.current ? widthRef.current : props.objWidth;
    const pathHeight = heightRef.current ? heightRef.current : props.objHeight;
    target.set({angle:0})
    target.scaleToWidth(pathWidth);
    target.scaleToHeight(pathHeight);
    target.set({angle:props.rotation})
    target.setCoords();
  }
}

//   canvas.on('object:scaling', ({ target }) => {
//   if (target.type === 'path') {
//     // Keep height in sync with width:
//     target.scaleY = target.scaleX;
//   }
// });
  canvas.on('object:modified', markAsChanged);
  canvas.on('object:modified', handleSizeChange);
  canvas.on('path:created', markAsChanged);
  // canvas.on('object:added', markAsChanged);
  // canvas.on('mouse:up', markAsChanged); // optional, fires after any mouse interaction
canvasRef.current.on('object:moving', ({ target }) => managePathMove(target));



  return () => {
    canvas.off('object:modified', markAsChanged);
    canvas.off('object:modified', handleSizeChange);
    canvas.off('path:created', markAsChanged);
    canvas.off('object:moving', ({ target }) => managePathMove(target))
    // canvas.off('object:added', markAsChanged);
    // canvas.off('mouse:up', markAsChanged);
    if (saveTimeout) clearTimeout(saveTimeout);
  };
}, [canvasRef.current, obj]);

  useEffect(() => {
    if (selfSaveRef.current) {
      selfSaveRef.current = false;
      return;
    }
    // When editing, placeObjects (called from loadJSON) already handles sizing
    // correctly including rotation. This second pass uses scaleToWidth/scaleToHeight
    // which factor in the rotated bounding box, causing rotated objects to shrink.
    if (props.editing) return;
    if (canvasRef.current && props.svgJSON) {
      setTimeout(() => {
        const objects = canvasRef.current && canvasRef.current.getObjects();
        const rect = objects && objects.find(obj => obj.type === 'rect');
        if (rect) {
          rect.set({
            strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
            scaleX: props.objWidth / rect.width,
            scaleY: props.objHeight / rect.height
          });
          setObj(rect);
          setObjType('rect');
        }

        const polygon = objects && objects.find(obj => obj.type === 'polygon');
        if (polygon) {
          polygon.set({
            strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
            scaleX: props.objWidth / polygon.width,
            scaleY: props.objHeight / polygon.height
          });
          setObj(polygon);
          setObjType('polygon');
        }

        const path = objects && objects.find(obj => obj.type === 'path');
        if (path) {
          path.set({
            strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
            scaleX: props.objWidth / path.width,
            scaleY: props.objHeight / path.height
          });
          setObj(path)
          setObjType('path');
        }

        const line = objects && objects.find(obj => obj.type === 'line');
        if (line) {
          line.set({
            strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio,
            scaleX: props.objWidth / line.width,
            scaleY: props.objHeight / line.height,
            strokeUniform: true
          });
          setObj(line)
          setObjType('line');
        }

        const ellipse = objects && objects.find(obj => obj.type === 'ellipse');
        if (ellipse) {
          ellipse.set({
            rx: props.objWidth/2,
            ry: props.objHeight/2,
            width: props.objWidth,
            height: props.objHeight,
            scaleY: 1,
            scaleX: 1,
            strokeWidth: props.svgJSON.objects[0].strokeWidth*props.zoomRatio
          });
          setObj(ellipse)
          setObjType('ellipse');
        }

      }, 50);

    }
  }, [canvasRef.current, props.svgJSON])

  // useEffect(() => {
  //   let svgString = canvasRef.current.toSVG();

  //   // If lineEnd is set to "arrowhead", inject marker definitions
  //   if (props.lineEnd === "arrowhead") {
  //     const arrowDef = `
  //       <defs>
  //         <marker id="arrowhead" markerWidth="10" markerHeight="7"
  //                 refX="10" refY="3.5" orient="auto" markerUnits="strokeWidth">
  //           <path d="M0,0 L10,3.5 L0,7 Z" fill="black" />
  //         </marker>
  //       </defs>
  //     `;

  //     // Add marker to <line> element and insert <defs>
  //     svgString = svgString.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
  //     svgString = svgString.replace('<g', `${arrowDef}<g`);
  //     svgString = svgString.replace(/<line /, '<line marker-end="url(#arrowhead)" ');
  //   }
  // }, [props.lineEnd])


  function measureObject(obj, zoomRatio, cb) {
    const cloneCanvas = new fabric.StaticCanvas(null, { enableRetinaScaling: false });
    obj.clone(cloned => {
      // reset position & scale
      cloned.set({ left: 0, top: 0, originX: 'left', originY: 'top', angle: 0 });
      cloneCanvas.add(cloned);
      cloneCanvas.renderAll();
      
      // boundingRect(true) includes stroke
      const bounds = cloned.getBoundingRect(true);
      const unzoomedW = bounds.width  / zoomRatio;
      const unzoomedH = bounds.height / zoomRatio;
      
      // round or keep float:
      const finalW = Math.round(unzoomedW);
      const finalH = Math.round(unzoomedH);
      
      cb(finalW, finalH, bounds.left, bounds.top);
    });
}



  const onSave = () => {
    let clonedObj;
    let x;
    let y;
    let width;
    let height;
    // if (sizeChangesRef.current) {
    //   strokeWidth = props.svgJSON.objects[0].strokeWidth/props.zoomRatio;
    // }

    // canvasRef.current
    //     .getActiveObject()
    //     .clone()
    //     .then((cloned) => {
    //       // cloned;
    //       clonedObj = cloned;
          
    //       // canvas.discardActiveObject();
    //       clonedObj.set({
    //         left: clonedObj.left+10,
    //         top: clonedObj.top+10,
    //         evented: true,
    //         originX: 'left',
    //         originY: 'top'
    //       });
    //       if (clonedObj instanceof fabric.ActiveSelection) {
    //         // active selection needs a reference to the canvas.
    //         clonedObj.canvas = canvasRef.current;
    //         clonedObj.forEachObject((obj) => {
    //           canvasRef.current.add(obj);
    //         });
    //         // this should solve the unselectability
    //         clonedObj.setCoords();
    //       } else {
    //         canvasRef.current.add(clonedObj);
    //       }
    //       // canvasRef.current.setActiveObject(clonedObj);
    //       canvasRef.current.requestRenderAll();

    //       console.log('clonedObj', clonedObj)
        
    //     });

    function runSave() {
      const activeObj = canvasRef.current.getActiveObject();
      if (!activeObj) {
        console.warn('No object selected!');
        return;
      }
      // Save live editing state before destructive serialization modifications
      const savedObjState = {
        left: activeObj.left,
        top: activeObj.top,
        scaleX: activeObj.scaleX,
        scaleY: activeObj.scaleY,
        angle: activeObj.angle,
        width: activeObj.width,
        height: activeObj.height,
        strokeWidth: activeObj.strokeWidth,
        originX: activeObj.originX,
        originY: activeObj.originY,
      };
      if (activeObj.type === 'ellipse') {
        savedObjState.rx = activeObj.rx;
        savedObjState.ry = activeObj.ry;
      }
      const savedCanvasWidth = canvasRef.current.width;
      const savedCanvasHeight = canvasRef.current.height;

      activeObj.set({angle: 0})
      const objW = activeObj.getScaledWidth();   // includes stroke
      const objH = activeObj.getScaledHeight();  // includes stroke
      let strokeWidth = 0;

      if (props.svgJSON && props.svgJSON.objects[0].strokeWidth) {
        strokeWidth = props.svgJSON.objects[0].strokeWidth;
      } 
       console.log('objW, objH', objW, objH);
      // console.log('stroke', strokeWidth, activeObj.strokeWidth/props.zoomRatio, activeObj.strokeWidth/props.zoomRatio !== strokeWidth)
      width = Math.round(objW/props.zoomRatio)-strokeWidth;
      height = Math.round(objH/props.zoomRatio)-strokeWidth;

      x = activeObj.left;
      y = activeObj.top;   
      
      switch (activeObj.type) {
        case 'rect':
          break;
        case 'polygon':
          break;
        case 'line':
          // Parent subtracts svgStrokePadding (2*strokeWidth) from dimension.width,
          // but getScaledWidth() only adds back 1*strokeWidth, so we add strokeWidth
          // to compensate and keep dimension.width stable across save cycles
          width = Math.round(objW/props.zoomRatio) + strokeWidth;
          height = Math.round(objH/props.zoomRatio) + strokeWidth;
          if (height < 30) {
            height = 30;
          }
          break;
        case 'path':
          // let margin = strokeWidth + 4;
          // width = objW + margin * 2;
          // height = objH + margin * 2;
          // x = x - margin;
          // y = y - margin;
          break;
        default:
          break;
      }
      
      canvasRef.current.absolutePan({ x: 0, y: 0 });
      canvasRef.current.setHeight(height + strokeWidth);
      canvasRef.current.setWidth(width + strokeWidth);

      function reFormat() {
        let strokeWidth = Math.round(activeObj.strokeWidth/props.zoomRatio);
        // if (activeTool === 'line' || activeTool === 'drawing') {
        //  strokeWidth = 2;
        // }
        let halfStroke = strokeWidth / 2;
        activeObj.set({
          left: halfStroke,
          top: halfStroke,
          originX: 'left',
          originY: 'top',
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          strokeMiterLimit: 10,
          strokeLineJoin: "round",
          strokeWidth: strokeWidth
        });
        activeObj.setCoords(); 
        activeObj.canvas && activeObj.canvas.requestRenderAll();

       function reFormatStep2(type){
         switch (type) {
          case 'rect':
            activeObj.set({
              width: width,
              height: height
            });
            break;
          case 'ellipse':
            activeObj.set({
              width: width,
              height: height,
              rx: width/2,
              ry: height/2
            });
            break;
          case 'polygon':
            activeObj.set({
              scaleX: width / activeObj.width,
              scaleY: height / activeObj.height
            });
            break;
          case 'line':
            activeObj.set({
              scaleX: width / activeObj.width,
              scaleY: height / activeObj.height
            });
            break;
          case 'path':
            activeObj.set({
              scaleX: width / activeObj.width,
              scaleY: height / activeObj.height
            });
            break;
          case 'arrow':
            activeObj.scaleToWidth(width);
            activeObj.scaleToHeight(height);
            break;
          default:
            break;
        }
        activeObj.setCoords(); 
        activeObj.canvas && activeObj.canvas.requestRenderAll();
       }
       reFormatStep2(activeObj.type);
      }

      reFormat();

      const svgJSON = canvasRef.current.toJSON();

      svgJSON.subtype = null;

      svgJSON.objects[0].strokeWidth = props.svgJSON ? props.svgJSON.objects[0].strokeWidth : 0;

      if (activeTool === 'line' || activeTool === 'drawing') {
         svgJSON.objects[0].strokeWidth = 2; 
      }

      if (activeTool) {
        svgJSON.subtype = activeTool;
      } else {

      if (activeObj.type === "path" || (props.svgJSON && props.svgJSON.subtype === 'path')) {
        svgJSON.subtype = 'path';
      }

      if (activeObj.type === "arrow" || (props.svgJSON && props.svgJSON.subtype === 'arrow')) {
        svgJSON.subtype = 'arrow';
      }

      if (activeObj.type === "star" || (props.svgJSON && props.svgJSON.subtype === 'star')) {
        svgJSON.subtype = 'star';
      }

      if (activeObj.type === "line" || (props.svgJSON && props.svgJSON.subtype === 'line')) {
        svgJSON.subtype = 'line';
      }

      if (activeObj.type === "rect" || (props.svgJSON && props.svgJSON.subtype === 'rect')) {
        svgJSON.subtype = 'rect';
      }

      if (activeObj.type === "ellipse" || (props.svgJSON && props.svgJSON.subtype === 'ellipse')) {
        svgJSON.subtype = 'ellipse';
      }

      }


      

      svgJSON.objects[0].scaleX = 1;
      svgJSON.objects[0].scaleY = 1;

      xPosRef.current = x;
      yPosRef.current = y;

      let strokeWidthPadding = 0;

      if (props.svgJSON && props.svgJSON.objects[0].strokeWidth) {
        strokeWidthPadding = props.svgJSON.objects[0].strokeWidth;
      } else {
        if (activeTool === 'line' || activeTool === 'drawing') {
          strokeWidthPadding = 6;
        }
      }

      const svgString = canvasRef.current.toSVG({
          suppressPreamble: false,
          viewBox: {
            x: 0,
            y: 0,
            width: width + strokeWidthPadding,
            height: height + strokeWidthPadding
          }
        });

        
     

      // Restore the live canvas and object to their pre-serialization editing state
      canvasRef.current.setWidth(savedCanvasWidth);
      canvasRef.current.setHeight(savedCanvasHeight);
      activeObj.set(savedObjState);
      activeObj.setCoords();
      canvasRef.current.setActiveObject(activeObj);
      canvasRef.current.requestRenderAll();

      const cleanedSvgString = svgString.replace(/opacity:\s*[^;]+;/g, '');

       svgJSON['objects'][0].opacity = 1;

      let dataJSON = {
        'svg_json': svgJSON,
        'svg_markup': cleanedSvgString,
        'display_id': props.activeDisplay.id,
        'width': width,
        'height': height,
        'id': props.id,
        'x_pos': parseInt(x/props.zoomRatio),
        'y_pos': parseInt(y/props.zoomRatio),
        'layer_name': activeTool
      }
      if (props.objId) {
        dataJSON['obj_id'] = props.objId
      }
      const api_url = Config.baseURLcms + 'componentdimension-svg/';

      console.log('onSave svg', props.objId, dataJSON, cleanedSvgString)

      
      function saveSVG(){

  
        if (activeTool) {

          function responseTask(response) {
            let sectionUrl = Config.baseURLcms + "narrative-section/" + props.id;
            apiCall("GET", sectionUrl, null, function(sectionResponse) {
              props.setIsDrawing(false);
              props.setActiveSectionObj(sectionResponse.data);
              props.setNewComponentDimension({id: response.data.id, 'file_format': 'svg'});
            }, null, props.setFormError);
          }

          setSaving(true);
          if (canvasRef.current) {
            canvasRef.current.discardActiveObject();
            canvasRef.current.renderAll();
          }
          apiCall('POST', api_url, dataJSON, responseTask, null, props.setFormError)

        } else {
        
          function responseTask() {
            
              // setTimeout(() => {
              //   // clonedObj && canvasRef.current.remove(clonedObj);
              //   // clonedObj && canvasRef.current.renderAll();
              //   console.log('removing clonedObj', clonedObj)
              // }, 100);
          }

          // apiCall('POST', api_url, dataJSON, responseTask, null, props.setFormError, props.setShowLoader)

          var newComponents = [ ...props.componentDimensions ];
          var newObj = newComponents.find(obj => (obj.id === props.objId));
          if (newObj) {
            newObj['width'] = width;
            newObj['height'] = height;
            newObj['x_pos'] = parseInt(x/props.zoomRatio);
            newObj['y_pos'] = parseInt(y/props.zoomRatio);
            newObj['svg_json'] = svgJSON;
            newObj['svg_markup'] = cleanedSvgString;

            setTimeout(() => {
              if (newObj) {
                if (document.getElementById('x_pos_dim_' + props.objId)){
                  document.getElementById('x_pos_dim_' + props.objId).value = newObj['x_pos']
                }
                if (document.getElementById('y_pos_dim_' + props.objId)) {
                  document.getElementById('y_pos_dim_' + props.objId).value = newObj['y_pos'];
                }
                if (document.getElementById('width_dim_' + props.objId)){
                  document.getElementById('width_dim_' + props.objId).value = newObj['width'];
                }
                if (document.getElementById('height_dim_' + props.objId)){
                  document.getElementById('height_dim_' + props.objId).value = newObj['height'];
                }
                
                
              }

            }, 50);
            selfSaveRef.current = true;
            props.setComponentDimensions(newComponents);
            props.setUnSavedChanges(true);
            
          
          }
        }
    }

    saveSVG()
    
    }
    
    runSave()
   
  


  }
  

  return (
    <span className={classNames('canvasBox', !loaded && "off", saving && "saving")} ref={canvasBoxRef} style={props.layerOpacity != null ? {opacity: props.layerOpacity / 100} : undefined}>
      <canvas id={uniqueIdRef.current}/>

     
    </span>
  );
  
}

export default App;
